import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'fsp-not-found',
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class NotFoundComponent {}
